/**
 * A tab left open across a deploy still asks for the old build's files (the item database's worker, the map art's,
 * the 3D database's wasm), which a new build no longer has: the server answers 404 for them (worker/index.ts). When
 * one of them fails, this asks whether the page's own main script is gone too, which means the tab is from an old
 * build, and reloads the page once to take the new one. Not twice within a minute, so a file missing for another
 * reason cannot keep the page reloading.
 */
const KEY = 'd2c.staleReload';

export async function reloadIfStale(): Promise<boolean> {
  const main = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]')?.src;
  if (!main) return false;   // the development server: nothing is built
  try {
    const r = await fetch(main, { method: 'HEAD', cache: 'no-store' });
    if (r.status !== 404) return false;
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;   // offline, or storage blocked: leave the page as it is
  }
  location.reload();
  return true;
}
